.lb {
  border-top: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  list-style: none;
  margin: 0;
  padding: 0;
  /* The tint used for the leading row and on hover; the cream section overrides it to white. */
  --lb-fill: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
}

.lb__row {
  border-bottom: 1px solid var(--color-primary-sand-200); /* PRIMARY_SAND_200 */
  transition: background 0.18s cubic-bezier(0.04, 0.4, 0.5, 0.95);
}

/* Carries the grid and the padding so the whole padded row is the click target. */
.lb__link {
  display: grid;
  grid-template-columns: 76px 112px 1fr auto;
  gap: 22px;
  align-items: center;
  padding: 18px 12px;
  color: inherit;
  text-decoration: none;
}

.lb__row:hover {
  background: var(--lb-fill);
}

/* The leading row is set apart: tinted, closed by a full rule, with a larger red rank and amount. */
.lb__row:first-child {
  border-bottom: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  background: var(--lb-fill);
}

/*
 * Rank and amount run an emphasis ramp: the leading row sits ~1.27x the rest, and both step down at
 * 768px and 560px. The sizes below are deliberately off the DS scale, which jumps 30 -> 44 -> 65 —
 * too coarse to hold that ratio, and snapping would land the mobile leading rank (38px) on the
 * desktop base size (44px). Only the base rank happens to coincide with a token.
 */
.lb__rank {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  font-size: 44px; /* HEADING_XL */
  line-height: 1;
  letter-spacing: -0.04em;
  color: var(--color-primary-sand-500); /* PRIMARY_SAND_500 */
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.lb__row:first-child .lb__rank {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
  font-size: 56px;
}

.lb__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.lb__thumb {
  width: 112px;
  height: 80px;
  border: 2px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-radius: 10px;
  overflow: hidden;
  background: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary-sand-500); /* PRIMARY_SAND_500 */
}

.lb__id {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.lb__name {
  display: block;
  font-size: 18px; /* COPY_L */
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  line-height: 1.25;
}

.lb__cat {
  display: block;
  font-size: 13px; /* HEADING_5XS */
  color: var(--color-text-tertiary); /* TEXT_TERTIARY */
  margin-top: 3px;
}

.lb__amt {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  font-size: 22px;
  letter-spacing: -0.015em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.lb__row:first-child .lb__amt {
  font-size: 28px;
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
}

/* Names the right-hand column for assistive tech; the header is visual only. */
.lb__valueLabel {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 1000px) {
  .lb__link {
    grid-template-columns: 52px 1fr auto;
    gap: 14px;
  }

  .lb__rank {
    font-size: 32px;
  }

  .lb__row:first-child .lb__rank {
    font-size: 38px;
  }

  .lb__thumb {
    display: none;
  }
}

@media (max-width: 560px) {
  .lb__amt {
    font-size: 17px;
  }

  .lb__row:first-child .lb__amt {
    font-size: 20px;
  }
}
